import whenDomReady from 'when-dom-ready';
// Polyfills
import objectFitImages from 'object-fit-images';
// Modules
import { collapsible } from './frontend/collapsible';
import { plyrOptions, modals } from './frontend/lightbox';
import { navToggle } from './frontend/navToggle';
import { navDropdown } from './frontend/navDropdown';
import { socialShare } from './frontend/socialShare';
import { scrollToPrettyNameElement } from './frontend/scrollHelper';
import { tabsFactory, scrollableTabsFactory } from './frontend/tabs';
import { StickyHeader } from './frontend/sticky-header';
import { ResizeListener } from './frontend/resize-listener';
import { CountdownFactory } from './frontend/countdown';
import { LoadMore } from './frontend/load-more';
import { bandRows, clicktrigger } from './frontend/clicktrigger';
import { formValidation } from './frontend/form-validation';
import { formRecaptcha } from './frontend/form-recaptcha';
import { TranslateFactory } from './frontend/translate';
import { TextWrapper } from './frontend/text-wrapper';
import { raceRegistrationOverview } from './frontend/raceRegistrationOverview';
import { LightboxFactory } from '@gebruederheitz/wp-block-video-overlay/dist/frontend';
import { SlideshowFactory } from '@gebruederheitz/wp-block-slideshow/dist/frontend';
import { shuffleCards } from './frontend/shuffleCards';
import {
    GdprEmbedFactory,
    ConsentManager,
    ElementsConsentManager,
    Usercentrics,
} from './frontend/gdpr-embed-loader';
import { embeds as embedsConfig } from '../../public/wp-content/themes/ghwp/config/global.yaml';
// Wrapped GTM dataLayer & fallback event proxy
import { gtm, eventProxy } from './frontend/gdpr-embed-loader/get-gdpr-utils';
import { RegistrationTimeline } from './frontend/registration-timeline';
import { LoadMoreBandsFactory } from './frontend/load-more-bands';
import { EmailObfuscationFactory } from './frontend/email-obfuscation';
import { cf7Checkbox } from './frontend/cf7-checkbox';

whenDomReady().then(async () => {
    // Set CSS variables for viewport sizing
    const resizeListener = new ResizeListener();
    // Sticky header & countdown ribbon
    new StickyHeader(resizeListener);
    objectFitImages();
    // Init pretty name scrolling on hash change and load
    scrollToPrettyNameElement();
    // Collapsibles + accordions
    collapsible();
    // Navigation
    navToggle();
    navDropdown();
    // Articles social share toggle visibility and copy to clipboard
    socialShare();
    // Tabs
    tabsFactory({ tabBreakpoint: false }, resizeListener);
    scrollableTabsFactory();
    // Slideshows & carousels
    new SlideshowFactory({ resizeListener });
    // Lightbox images; content modals
    modals();
    const lbf = new LightboxFactory(plyrOptions);
    // init only image lightboxes here, videos are handled by GdprLightboxEmbeds
    lbf.images();
    // Countdown to target on stage blocks
    new CountdownFactory();
    // Load more button for article teasers
    new LoadMore();
    // Clicktrigger for Sponsors "flyouts"
    clicktrigger();
    // clicktrigger fix: show bands inside hidden rows
    bandRows();
    // Helper for styled checkboxes
    cf7Checkbox();
    // Assistant for HTML5 form validation
    formValidation();
    // ReCaptcha
    formRecaptcha();
    // Wrap special text keywords in a specified element
    new TextWrapper();
    // Race registration overview
    new raceRegistrationOverview();
    // Animated progress bar for registration timeline
    new RegistrationTimeline();
    // Fake "load more" button for bands
    new LoadMoreBandsFactory();
    // Email address obfuscation
    new EmailObfuscationFactory();
    // Shuffle cards in image cards container
    shuffleCards();

    //------------------------------------------------------------------------//
    //======= GDPR SECTION
    //------------------------------------------------------------------------//
    // Conditionally execute scripts based on user consent to services
    const consentManager = new ConsentManager(
        { embeds: embedsConfig },
        gtm,
        eventProxy
    );
    // Gdpr-compliant embeds and stuff
    new GdprEmbedFactory(
        { embeds: embedsConfig, lightboxFactory: lbf },
        consentManager
    );
    new ElementsConsentManager(consentManager, { embeds: embedsConfig });
    // Handle translation with Google Translate
    new TranslateFactory(consentManager, resizeListener);
    // Gdpr-compliant embeds and stuff
    // new GdprEmbedFactory({ embeds: embedsConfig }, wrappedGtm, eventProxy);
    Usercentrics.listen('[href="#uc-modal"]');
});
